export default defineAppConfig({
  ui: {
    colors: {
      primary: 'blaster',
      neutral: 'slate',
    },
    modal: {
      slots: {
        overlay: 'fixed inset-0 bg-black/60',
      },
      variants: {
        fullscreen: {
          // Nuxt UI's default with a larger radius and a hairline border in place of the ring.
          false: {
            content: 'top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[calc(100vw-2rem)] max-w-lg max-h-[calc(100dvh-2rem)] sm:max-h-[calc(100dvh-4rem)] rounded-[18px] shadow-2xl border border-(--line) overflow-hidden',
          },
        },
      },
    },
    button: {
      slots: {
        base: 'rounded-full font-semibold',
      },
      defaultVariants: {
        color: 'primary',
        variant: 'solid',
        size: 'md',
      }
    },
    card: {
      defaultVariants: {
        variant: 'outline',
      }
    },
    badge: {
      defaultVariants: {
        color: 'primary',
        variant: 'soft',
        size: 'md',
      }
    }
  }
})
